import { createApplication } from '@aviv-unified-frontend/runtime/lifecycle';
import { createLogger } from '@aviv-unified-frontend/runtime/monitoring';
import { handleServerRequest, } from '@search/serp_common/helpers/handleServerRequest/handleServerRequest';
import { App } from './App';
export default createApplication({
    logger: createLogger({ name: 'app_serp', version: 1 }),
    Component: App,
    id: 'app_serp',
    async onServerRequest(request, response) {
        const serverData = await handleServerRequest(request, response);
        return serverData;
    },
});
